import React, { useState } from "react"
import { Form, Input, Button, message as antdMessage, Spin } from "antd"
import { authApi } from "../../Apis/authApis"
import { useNavigate } from "react-router-dom"
import { translations } from "../../utils/Translation/staticTranslation"
import ToggleLogin from "../../components/Common/ToggleLogin"
import useLanguage from "../../services/useLanguage"
import { getMarketingWebsiteUrl } from "../../utils/getMarketingWebsiteUrl"

const ForgetPassword = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { language, handleLanguageChange } = useLanguage()
  const lang = localStorage.getItem("language") || "ar"
  const websiteUrl = getMarketingWebsiteUrl(lang)

  const forgetPassword = translations[lang]?.forget_passwordPage
  const loginPage = translations[lang]?.loginPage
  const commonErrorMsg = translations[lang]?.common_error_msg

  const onFinish = async (values) => {
    const payload = {
      email: values.email,
    }

    try {
      setLoading(true)
      const response = await authApi.forgotPassword(payload)
      if (response.status === 200) {
        antdMessage.success(forgetPassword?.success_msg, 8)
        form.resetFields()
      }
    } catch (error) {
      const message =
        lang === "en"
          ? error.response?.data?.email
          : error.response?.data?.emailArabic

      antdMessage.error(message)
      console.error("Error:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value.toLowerCase()

    if (value.includes("+")) {
      antdMessage.error(commonErrorMsg?.email_cannot_symbol)
      return
    }

    form.setFieldsValue({ email: value })
  }

  return (
    <>
      <div className="signup-inner">
        <div className="signup-left">
          <div className="signup-left-logo">
            <a href={websiteUrl}>
              <img src="/signup/Zory brown.svg" alt="Zory Logo" />
            </a>
          </div>
        </div>

        <div className="signup-right">
          <div className="sign-l-header" dir={lang === "ar" ? "rtl" : "ltr"}>
            <div className="back-arrow" onClick={() => navigate("/")}>
              <img
                src="/signup/arrowBack.svg"
                alt=""
                className={lang === "ar" ? "rotated-arrow" : ""}
              />
              {lang === "ar" ? "رجوع" : "Back"}
            </div>
            <div className="logo-sign">
              <a href={websiteUrl}>
                <img src="/signup/Zorysmall.svg" alt="Zory Logo" />
              </a>
            </div>
            <div className="lang-toggle">
              <ToggleLogin
                toggleLanguage={handleLanguageChange}
                currentLanguage={language}
              />
            </div>
          </div>

          <div className="content">
            <h3 className="font-Montserrat00">
              {forgetPassword?.forget_password}
            </h3>
            <span className="font-Montserrat-300">
              {forgetPassword?.forgort_password_description}
            </span>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: "24px" }}
          >
            <Form.Item
              label={
                <span style={lang === "ar" ? { fontSize: "13px" } : undefined}>
                  {lang === "ar" ? "بريد إلكتروني" : "Email"}
                </span>
              }
              name="email"
              rules={[
                {
                  required: true,
                  message: loginPage?.email_error_1,
                },
                {
                  type: "email",
                  message: loginPage?.email_error_2,
                },
                {
                  validator: (_, value) =>
                    value && value.includes("+")
                      ? Promise.reject(commonErrorMsg?.email_cannot_symbol)
                      : Promise.resolve(),
                },
              ]}
              labelCol={{ span: 24 }}
            >
              <Input
                className="custom-input"
                placeholder={loginPage?.email_placeholder}
                onChange={handleEmailChange}
                style={{
                  background: "#ffffff",
                  border: "1px solid rgba(132, 135, 136, 0.25)",
                  height: 50,
                  borderRadius: 12,
                }}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  width: "100%",
                  fontSize: "18px",
                  height: 50,
                  borderRadius: 12,
                  background: "#1d869a",
                  border: "none",
                }}
              >
                {loading ? <Spin /> : forgetPassword?.send_reset_inxtruction}
              </Button>
            </Form.Item>

            <div
              style={{
                textAlign: "center",
                marginTop: "16px",
              }}
            >
              <a
                href="/login"
                onClick={(e) => {
                  e.preventDefault()
                  navigate("/login")
                }}
                style={{
                  fontSize: 14,
                  color: "#1d869a",
                  textDecoration: "none",
                }}
              >
                {lang === "ar" ? "العودة إلى تسجيل الدخول" : "Back to Login"}
              </a>
            </div>
          </Form>
        </div>
      </div>
    </>
  )
}

export default ForgetPassword
